<template>
  <div class="ma-4">
   <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
   <ClientNav class="hideOnPrint"/>
   <v-row dense class="hideOnPrint">
    <v-col cols="12" lg="3" xl="2">
      <ClientSide />
    </v-col>
    <v-col cols="12" lg="9" xl="10">
      <v-card class="pa-2" outlined tile height="100%">
    <v-data-table
      :headers="headers"
      :items="rights"
      sort-by="reviewDate"
      sort-desc
      :loading="isLoading"
      loading-text="Loading Human Rights"
      :search="search"
      height="550"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Human Rights Data Collection</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="search"
            label="search"
            class="desktop"
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn 
              fab 
              small
              @click="printTable()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!directCare"
              >
              <v-icon>print</v-icon>
          </v-btn>
        </v-toolbar>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="mobile ml-5 mr-5 mb-3 mt-3"
        ></v-text-field>
        
      </template>

     
      <template v-slot:no-data>
        <v-btn color="#2b3990" class="white--text" @click="getRights()">Reset</v-btn>
      </template>
    </v-data-table>
      </v-card>
    </v-col>
    </v-row>
    <Foot class="hideOnPrint"/>


    <div id="printTable">
      <h2 class="text-center ma-3">{{clientName}}'s' Human Rights Data Collection</h2>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="rights"
            sort-by="reviewDate"
            sort-desc
            :loading="isLoading"
            loading-text="Loading Human Rights"
            :search="search"
            height="auto"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Human Rights Data Collection</v-toolbar-title>      
              </v-toolbar>
              
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import moment from 'moment'
import { mapActions } from "vuex";


const url = require("../../client_config/config").url;

export default {
  components: {
      ClientNav,
      ClientSide,
      Foot,
  },
  data: function() {
    return {
      headers: [
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'Date',
        },
        { text: "Service Item", value: "Service.ServiceItem" },
        { text: "Notes", value: "Notes" },
        { text: "Service Item", value: "Service.Description" },
        { text: "Signature", value: "Signature" },
      ],
      
      
      msg: false,
      search: "",
      text:"",
      rights: [],
      tempData: [],
      users: [],
      staff: "",
      clientID: this.$route.params.clientID,
      rightID: this.$route.params.rightID,
      userID: localStorage.getItem("userID"),
      isLoading: false
     
    };
  },

  computed: {
    clientName() {
      // `this` points to the component instance
      return this.$store.state.clients.client.Name;
    }
  },

  watch: {
    
  },

  created() {
    this.getRights();
    this.getClientInfo(this.clientID)

  },

  methods: {
    ...mapActions({
      getClientInfo: "clients/getClient",
    }),
    initialize() {
      this.rights = [];
    },
    
    getRights: function() {
      this.isLoading = true;
      axios.get(`${url}/adl/client/${this.clientID}`).then((res) => {
        var temp = res.data.adl;
        for (var i=0; i < temp.length; i++){
            temp[i].Date = moment(temp[i].Date).format("MM/DD/YYYY")
            if(temp[i].Service.HumanRights == this.rightID){
              this.rights.push(temp[i])
            }
            
        }
      }).finally(() => this.isLoading = false);
    },

    getUsers: function() {
        axios.get(`${url}/users`).then(async res => {
            this.users = res.data.users;
            for (var i=0; i < this.users.length; i++){
              if (this.userID == this.users[i]._id) {
                this.staff = this.users[i].Name
              }
            }
            this.newEnteredBy = this.staff + " - " + new Date(); 
        });
      },

    printTable() {
        document.getElementById('printTable').style.display = "block";
        // document.getElementById('printItem').style.display = "none";


        window.print()
      
    },

    printItem() {
        document.getElementById('printItem').style.display = "block";
        document.getElementById('printTable').style.display = "none";

      
        window.print()
    },

  },

};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }

  #printTable{
    display: none;
  }

  #printItem{
    display: none;
  }

  @media only screen and (min-width: 768px) {
      .mobile {
        display: none;
      }
    }

    @media only screen and (max-width: 600px) {
      .desktop {
        display: none;
      }

    }

    @media print {  
      #printTable{ 
      display: block; 
      border: none; 
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;

      }
      #printItem{ 
      display: block; 
      border: none; 
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
      

      }
      .hideOnPrint {
        display: none;
        border: none; 
      }

      nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none; 

      }

      @page { margin: 0; }
      body { margin: 1.6cm; }
    
      
    } 

  #hrcSignaturePad {
    cursor: crosshair;
  }

  .signature-card .v-card__actions button {
    flex: 1 0 auto !important;
  }

  canvas {
    display: block;
    margin: auto;
  }
  #hrcSignaturePad > div {
    box-shadow: rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px,
      rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px,
      rgb(0 0 0 / 9%) 0px -3px 5px;
    margin: 15px auto;
    border-radius: 5px;
    border: none;
  }
  @media only screen and (max-width: 768px) {
    .signature-card {
      width: 100%;
    }
  }
</style>